<template>
  <div class="about">
    <h1>a site for events</h1>
    <img alt="Vue logo" src="../assets/logo.png">
  </div>
</template>
